export const SET_THEME_TO_LIGHT_MODE = "SET_THEME_TO_LIGHT_MODE"
export const SET_THEME_TO_DARK_MODE = "SET_THEME_TO_DARK_MODE"
